import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class PowerBiReportResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.embededToken = {
            token: "",
            tokenId: "",
            expiration: new Date()
        };
        this.embededUrls = [];
    }
    pk() {
        return this.embededToken?.tokenId ?? "";
    }
}
PowerBiReportResource.urlRoot = apiResourceUrl("powerbi-report");
export { PowerBiReportResource };
//# sourceMappingURL=PowerBiReportResource.js.map